module.exports = __webpack_public_path__ + "img/seiberling.26eeccae.webp";